import axios from "axios";

export const postData = async (data: any, endpoint: string): Promise<any> => {
    const token = localStorage.getItem('token')
    const tokenValue: any = token

    try {
        const response = await axios.post(endpoint, data, {
            headers: { Authorization: `Bearer ${tokenValue}` }
        });
        if (response.data.status === 1) {
            return { data: response.data, error: null };
        }
        return { data: null, error: response.data.message }
    } catch (error: any) {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
        }

        return { data: null, error: error };
    }
};

export const putData = async (data: any, endpoint: string): Promise<any> => {
    const token = localStorage.getItem('token')
    const tokenValue: any = token
    try {
        const response = await axios.put(endpoint, data, {
            headers: { Authorization: `Bearer ${tokenValue}` }
        });
        if (response.data.status === 1) {
            return { data: response.data, error: null };
        }
        return { data: null, error: response.data.message }
    } catch (error: any) {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
        }

        return { data: null, error: error };
    }
};

export const deleteData = async (endpoint: string): Promise<any> => {
    const token = localStorage.getItem('token')
    const tokenValue: any = token
    try {
        const response = await axios.delete(endpoint, {
            headers: { Authorization: `Bearer ${tokenValue}` }
        });
        if (response.data.status === 1) {
            if (response.data.data > 0) {
                return { data: response.data, error: null };
            } else {
                return { data: false, error: response.data.message };
            }
        }
        return { data: null, error: response.data.message }
    } catch (error: any) {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
        }

        return { data: null, error: error };
    }
};

export const getData = async (endpoint: string): Promise<any> => {
    const token = localStorage.getItem('token')
    const tokenValue: any = token

    try {
        const response = await axios.get(endpoint, {
            headers: { Authorization: `Bearer ${tokenValue}` }
        });
        if (response.data.status === 1) {
            return { data: response.data, error: null };
        }
        return { data: null, error: response.data.message }
    } catch (error: any) {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
        }

        return { data: null, error: error };
    }
};